<template>
  <div style="display: contents">
    <template v-for="(field, index) in fields" :key="index">
      <v-list-item
        v-if="!field.entityFields || depth >= maxDepth"
        class="py-0 min-h-0"
      >
        <template #prepend>
          <v-checkbox
            v-model="field.checked"
            hide-details
            density="compact"
            class="mr-2"
            @update:model-value="(val) => { if (val) emit('child-checked') }"
          />
        </template>
        <v-list-item-title class="text-sm">{{ field.name }}</v-list-item-title>
      </v-list-item>

      <v-list-group v-else class="py-0 min-h-0">
        <template #activator="{ props }">
          <v-list-item
            v-bind="props"
            class="py-0 min-h-0"
          >
            <template #prepend>
              <v-checkbox
                v-model="field.checked"
                hide-details
                density="compact"
                class="mr-2"
                @click.stop
                @update:model-value="(val) => onParentChecked(val, field)"
              />
            </template>
            <v-list-item-title class="text-sm">{{ field.name }}</v-list-item-title>
          </v-list-item>
        </template>

        <entity-field-selector-fields
          :fields="field.entityFields"
          :depth="depth + 1"
          :maxDepth="maxDepth"
          @child-checked="field.checked = true; emit('child-checked')"
        />
      </v-list-group>
    </template>
  </div>
</template>

<script setup>
defineProps({
  fields: Array,
  depth: { type: Number, default: 1 },
  maxDepth: { type: Number, default: 2 }
})

const emit = defineEmits(['child-checked'])

const uncheckAll = (fields) => {
  for (const f of (fields || [])) {
    f.checked = false
    if (f.entityFields) {
      uncheckAll(f.entityFields)
    }
  }
}

const onParentChecked = (checked, field) => {
  if (!checked && field.entityFields) {
    uncheckAll(field.entityFields)
  }
  if (checked) {
    emit('child-checked')
  }
}
</script>

<style scoped>
.v-list-item {
  padding: 0 !important;
}

.v-list-item--density-compact:not(.v-list-item--nav).v-list-item--one-line {
  padding-inline: 0;
}

::v-deep(.v-list-group) {
  --indent-padding: 0px !important;
}

.v-list-group__items .v-list-item {
  padding-inline-start: 16px !important;
}

.v-list-group__items .v-list-group__items .v-list-item {
  padding-inline-start: 32px !important;
}

.v-list-item--density-compact.v-list-item--one-line {
  min-height: 28px;
  &.v-list-item--prepend {
    direction: rtl;
    text-align: left;
  }
}

.v-list-group__items .v-list-item--density-compact.v-list-item--one-line {
  direction: ltr;
}

::v-deep(.v-list-item__append .v-list-item__spacer) {
  width: 8px !important;
}

.v-input--density-compact {
  --v-input-control-height: 28px;
}
</style>
